<rid-demo-page [title]="'<rid-content-card>'" previousRoute="/component-lab">
  <rid-content-card [fullWidth]="true" text="content" />
  <rid-content-card [fullWidth]="true" [isClickable]="true" text="clickable" />
  <rid-content-card [fullWidth]="true" state="CORRECT" text="correct" />
  <rid-content-card [fullWidth]="true" state="INCORRECT" text="incorrect" />
  <rid-content-card [fullWidth]="true" state="DISABLED" text="disabled" />
</rid-demo-page>
